/**
 * CodeElement — F12.H T12.H.5.
 *
 * Blok kodu (`<pre><code>`) z opcjonalnym językiem (label nad blokiem).
 * Bez syntax highlightingu (na MVP) — czysty monospace tekst.
 *
 * Settings shape:
 *   { code: string, language?: string }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

export const CodeElement: LayoutElementDefinition = {
  type: 'code',
  category: 'tresc',
  isContainer: false,
  label: 'Kod',
  icon: 'Code',
  defaultSettings: () => ({
    code: '// Przykładowy kod\nconst x = 42;',
    language: '',
  }),
  propertiesEditor: ({ settings, onChange }) => {
    const code = String(settings.code ?? '');
    const language = String(settings.language ?? '');
    return (
      <div className="space-y-3" data-testid="code-properties-editor">
        <div>
          <label className="mb-1 block text-xs font-medium text-text-secondary">
            Język (opcjonalnie)
          </label>
          <input
            type="text"
            value={language}
            onChange={(e) => onChange({ language: e.target.value })}
            placeholder="np. javascript, sql"
            className="w-full rounded-md border border-border-primary bg-bg-primary px-2 py-1 text-sm"
            data-testid="code-prop-language"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-text-secondary">Kod</label>
          <textarea
            value={code}
            onChange={(e) => onChange({ code: e.target.value })}
            rows={8}
            className="w-full rounded-md border border-border-primary bg-bg-primary px-2 py-1 font-mono text-xs"
            data-testid="code-prop-code"
          />
        </div>
      </div>
    );
  },
  render: ({ element, mode }) => {
    const settings = (element.settings ?? {}) as { code?: string; language?: string };
    const code = settings.code ?? '';
    const language = settings.language?.trim() ?? '';

    if (!code && mode === 'builder') {
      return (
        <div
          className="rounded border border-dashed border-border-secondary p-3 text-xs text-text-tertiary"
          data-testid={`code-element-${element.id}`}
        >
          (pusty blok kodu — wpisz treść w panelu właściwości)
        </div>
      );
    }

    return (
      <div
        data-testid={`code-element-${element.id}`}
        data-element-type="code"
        className="overflow-hidden rounded-md border border-border-primary bg-bg-tertiary"
      >
        {language && (
          <div className="border-b border-border-primary bg-bg-secondary px-3 py-1 text-xs font-medium text-text-tertiary">
            {language}
          </div>
        )}
        <pre className="overflow-x-auto p-3 text-xs">
          <code className="font-mono text-text-primary whitespace-pre">{code}</code>
        </pre>
      </div>
    );
  },
};
